//core
import React from "react";
import arePropsEqual from "react-fast-compare";
import {makeStyles} from "@mui/styles";
import {format, parse} from "date-fns";

//hooks
import { useLocale } from "../../../../../customHooks/useLocale";

interface IDateTime {
  value: any;
  fullDate?: boolean;
  hideSeconds?: boolean;
  monthlyDate?: boolean;
}

const useStyles = makeStyles({
  text: {
    color: 'inherit',
    whiteSpace: 'nowrap',
  }
});

const DateTimeRange = ({
  value,
  fullDate = false,
  hideSeconds = false,
  monthlyDate = false,
}: IDateTime) => {
  const styles = useStyles();
  const locale = useLocale();

  const val: string[] = !!value ? value.split(' - ') : [];

  const getDateFormat = () => {
    if (monthlyDate) return locale.monthly;
    if (fullDate) {
      return hideSeconds ? locale.fullFormatWithOutSeconds : locale.fullFormat;
    }
    return locale.format
  };

  const getParseFormat = () => monthlyDate ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss';

  const date = !!value && val.reduce((acc, item, i) => {
    try {
      const parsedDate = parse(item.trim(), getParseFormat(), new Date(), { locale: locale.locale });
      return acc + `${format(parsedDate, getDateFormat(), {locale: locale.locale})}${val.length !== i+1 ? ' - ' : ''}`
    } catch (e) {
      return acc + `${format(new Date(item), getDateFormat(), {locale: locale.locale})}${val.length !== i+1 ? ' - ' : ''}`
    }
  }, '');

  return (
    <span className={styles.text}>
      { value ? date : '—' }
    </span>
  );
};

export default React.memo(DateTimeRange, arePropsEqual);
